// extracted by mini-css-extract-plugin
export default {"container":"QuienesSomos_container__frDDw","section":"QuienesSomos_section__71wjk","title":"QuienesSomos_title__5fRcA","text":"QuienesSomos_text__1nqy3"};